const DEFAULT_FILL_STYLE = {
  fill: 'rgba(5, 146, 232, 0.2)',
  stroke: {
    color: 'rgba(5, 146, 232, 1)',
    width: 1,
    lineDash: [4, 2]
  }
}

function stripRichTextWrapper (value) {
  return typeof value === 'string' ? value.replace(/(<\/?p.*?>)/gi, '') : value
}

function parseRepeatedJson (value) {
  let current = stripRichTextWrapper(value)
  for (let i = 0; i < 5 && typeof current === 'string'; i++) {
    const trimmed = current.trim()
    if (trimmed === '') return ''
    try {
      current = JSON.parse(trimmed)
    } catch (e) {
      return current
    }
  }
  return current
}

function isValidFillcolorItem (item) {
  return item &&
    typeof item === 'object' &&
    !Array.isArray(item) &&
    item.code !== undefined &&
    item.name !== undefined &&
    Array.isArray(item.style) &&
    item.style.length > 0
}

export function isValidFillcolorList (value) {
  return Array.isArray(value) && value.length > 0 && value.every(isValidFillcolorItem)
}

function getGeojsonItems (geojson) {
  if (!geojson) return []
  if (Array.isArray(geojson)) return geojson
  if (Array.isArray(geojson.features)) {
    return geojson.features.map(feature => feature.properties || feature)
  }
  return [geojson]
}

export function buildDefaultFillcolor (geojson) {
  return getGeojsonItems(geojson)
    .map(item => ({
      code: item.code || item.adcode,
      name: item.name,
      style: [JSON.parse(JSON.stringify(DEFAULT_FILL_STYLE))]
    }))
    .filter(isValidFillcolorItem)
}

export function normalizeFillcolorForForm (value, geojson) {
  const parsed = parseRepeatedJson(value)
  if (isValidFillcolorList(parsed)) return parsed
  return buildDefaultFillcolor(geojson)
}
